import { render, staticRenderFns } from "./tenantDataCopy.vue?vue&type=template&id=17dae3f7&scoped=true&"
import script from "./tenantDataCopy.vue?vue&type=script&lang=js&"
export * from "./tenantDataCopy.vue?vue&type=script&lang=js&"
import style0 from "./tenantDataCopy.vue?vue&type=style&index=0&id=17dae3f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dae3f7",
  null
  
)

export default component.exports